export const getQueryParam = (key) => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
};
/*
 * Get the region and client values from the URL. URL will be in the format of https://<domain>/region/client
 */
export const getRegionAndClient = () => {
    const region = window.location.pathname.split('/')[1];
    const client = window.location.pathname.split('/')[2];
    return { region, client };
};
/*
 * Get the base path for the application, which is the region and client after the domain, e.g., https://<domain>/region/client
 */
export const getBasePath = () => {
    const { region, client } = getRegionAndClient();
    if (!region || !client)
        return '/';
    return `/${region}/${client}`;
};
/*
 * Get the base URL for the application, which is a full URL including the region and client after the domain,
 * e.g., https://<domain>/region/client
 */
export const getBaseUrl = (includeClientCode = true) => {
    const { region, client } = getRegionAndClient();
    const clientPart = includeClientCode ? `/${client || '-'}` : '';
    return `${window.location.origin}/${region || '-'}${clientPart}`;
};
